// extracted by mini-css-extract-plugin
export default {"displayImage":"DisplayImage_displayImage__Rg4ta","flipButton":"DisplayImage_flipButton__fd6du"};